import NewSSO from '../../components/login/NewSSO';

const NewSSOPortal = (props) => (
  <NewSSO {...props} />
);

export default NewSSOPortal;
